/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * AI Enablement Platform
 * Enterprise AI enablement analysis and recommendations platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptInviteExistingUserRequest,
  AcceptInviteRequest,
  AcceptInviteResponse,
  BackendLoginPageV1AuthLoginGetParams,
  BodySamlSsoAcsV1AuthSsoSamlAcsPost,
  ChangePasswordRequest,
  CreateUserRequest,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  GetSsoLoginOptionsV1AuthSsoOptionsGetParams,
  HTTPValidationError,
  InviteInfoResponse,
  LoginRequest,
  LoginResponse,
  OidcSsoCallbackV1AuthSsoOidcCallbackGetParams,
  PasswordResetConfirmRequest,
  PermissionCheckRequest,
  PermissionCheckResponse,
  RefreshTokenRequest,
  SSOCodeExchangeRequest,
  SSOCodeExchangeResponse,
  SSODiscoveryResponse,
  SSOLoginOptionsResponse,
  SetDefaultTenantRequest,
  SetDefaultTenantResponse,
  StartOidcSsoLoginV1AuthSsoOidcStartGetParams,
  StartSamlSsoLoginV1AuthSsoSamlStartGetParams,
  SwitchTenantRequest,
  SwitchTenantResponse,
  TenantMembershipsResponse,
  TerminateAllSessionsV1AuthSessionsDeleteParams,
  UserProfile,
  UserSessionsResponse
} from '.././models';

import { customInstance } from '../../services/api-client';




/**
 * Minimal backend-hosted login page for backend-only MCP OAuth deployments.
 * @summary Backend Login Page
 */
export const backendLoginPageV1AuthLoginGet = (
    params?: BackendLoginPageV1AuthLoginGetParams,
 signal?: AbortSignal
) => {


      return customInstance<string>(
      {url: `/v1/auth/login`, method: 'GET',
        params, signal
    },
      );
    }




export const getBackendLoginPageV1AuthLoginGetQueryKey = (params?: BackendLoginPageV1AuthLoginGetParams,) => {
    return [
    `/v1/auth/login`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getBackendLoginPageV1AuthLoginGetQueryOptions = <TData = Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>, TError = HTTPValidationError>(params?: BackendLoginPageV1AuthLoginGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBackendLoginPageV1AuthLoginGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>> = ({ signal }) => backendLoginPageV1AuthLoginGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BackendLoginPageV1AuthLoginGetQueryResult = NonNullable<Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>>
export type BackendLoginPageV1AuthLoginGetQueryError = HTTPValidationError


export function useBackendLoginPageV1AuthLoginGet<TData = Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>, TError = HTTPValidationError>(
 params: undefined |  BackendLoginPageV1AuthLoginGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>,
          TError,
          Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBackendLoginPageV1AuthLoginGet<TData = Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>, TError = HTTPValidationError>(
 params?: BackendLoginPageV1AuthLoginGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>,
          TError,
          Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBackendLoginPageV1AuthLoginGet<TData = Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>, TError = HTTPValidationError>(
 params?: BackendLoginPageV1AuthLoginGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Backend Login Page
 */

export function useBackendLoginPageV1AuthLoginGet<TData = Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>, TError = HTTPValidationError>(
 params?: BackendLoginPageV1AuthLoginGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof backendLoginPageV1AuthLoginGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBackendLoginPageV1AuthLoginGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Authenticate user and create session.

Returns JWT access token and refresh token for authenticated user.
Includes tenant memberships for multi-tenant users.
 * @summary Login
 */
export const loginV1AuthLoginPost = (
    loginRequest: LoginRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LoginResponse>(
      {url: `/v1/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest, signal
    },
      );
    }
  


export const getLoginV1AuthLoginPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginV1AuthLoginPost>>, TError,{data: LoginRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof loginV1AuthLoginPost>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['loginV1AuthLoginPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginV1AuthLoginPost>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  loginV1AuthLoginPost(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type LoginV1AuthLoginPostMutationResult = NonNullable<Awaited<ReturnType<typeof loginV1AuthLoginPost>>>
    export type LoginV1AuthLoginPostMutationBody = LoginRequest
    export type LoginV1AuthLoginPostMutationError = HTTPValidationError

    /**
 * @summary Login
 */
export const useLoginV1AuthLoginPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginV1AuthLoginPost>>, TError,{data: LoginRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loginV1AuthLoginPost>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {

      const mutationOptions = getLoginV1AuthLoginPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Return all runtime-enabled SSO providers for the login page.

This is an unauthenticated endpoint that returns only minimal, non-secret
provider metadata so the login page can render branded SSO buttons before
the user enters an email address.
 * @summary Discover Sso Providers
 */
export const discoverSsoProvidersV1AuthSsoDiscoveryGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SSODiscoveryResponse>(
      {url: `/v1/auth/sso/discovery`, method: 'GET', signal
    },
      );
    }
  



export const getDiscoverSsoProvidersV1AuthSsoDiscoveryGetQueryKey = () => {
    return [
    `/v1/auth/sso/discovery`
    ] as const;
    }

    
export const getDiscoverSsoProvidersV1AuthSsoDiscoveryGetQueryOptions = <TData = Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscoverSsoProvidersV1AuthSsoDiscoveryGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>> = ({ signal }) => discoverSsoProvidersV1AuthSsoDiscoveryGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DiscoverSsoProvidersV1AuthSsoDiscoveryGetQueryResult = NonNullable<Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>>
export type DiscoverSsoProvidersV1AuthSsoDiscoveryGetQueryError = unknown


export function useDiscoverSsoProvidersV1AuthSsoDiscoveryGet<TData = Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>,
          TError,
          Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDiscoverSsoProvidersV1AuthSsoDiscoveryGet<TData = Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>,
          TError,
          Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDiscoverSsoProvidersV1AuthSsoDiscoveryGet<TData = Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Discover Sso Providers
 */

export function useDiscoverSsoProvidersV1AuthSsoDiscoveryGet<TData = Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof discoverSsoProvidersV1AuthSsoDiscoveryGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDiscoverSsoProvidersV1AuthSsoDiscoveryGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Return available login methods for the resolved tenant context.
 * @summary Get Sso Login Options
 */
export const getSsoLoginOptionsV1AuthSsoOptionsGet = (
    params: GetSsoLoginOptionsV1AuthSsoOptionsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SSOLoginOptionsResponse>(
      {url: `/v1/auth/sso/options`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetSsoLoginOptionsV1AuthSsoOptionsGetQueryKey = (params?: GetSsoLoginOptionsV1AuthSsoOptionsGetParams,) => {
    return [
    `/v1/auth/sso/options`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSsoLoginOptionsV1AuthSsoOptionsGetQueryOptions = <TData = Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>, TError = HTTPValidationError>(params: GetSsoLoginOptionsV1AuthSsoOptionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSsoLoginOptionsV1AuthSsoOptionsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>> = ({ signal }) => getSsoLoginOptionsV1AuthSsoOptionsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSsoLoginOptionsV1AuthSsoOptionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>>
export type GetSsoLoginOptionsV1AuthSsoOptionsGetQueryError = HTTPValidationError


export function useGetSsoLoginOptionsV1AuthSsoOptionsGet<TData = Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>, TError = HTTPValidationError>(
 params: GetSsoLoginOptionsV1AuthSsoOptionsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>,
          TError,
          Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSsoLoginOptionsV1AuthSsoOptionsGet<TData = Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>, TError = HTTPValidationError>(
 params: GetSsoLoginOptionsV1AuthSsoOptionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>,
          TError,
          Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSsoLoginOptionsV1AuthSsoOptionsGet<TData = Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>, TError = HTTPValidationError>(
 params: GetSsoLoginOptionsV1AuthSsoOptionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Sso Login Options
 */

export function useGetSsoLoginOptionsV1AuthSsoOptionsGet<TData = Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>, TError = HTTPValidationError>(
 params: GetSsoLoginOptionsV1AuthSsoOptionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSsoLoginOptionsV1AuthSsoOptionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSsoLoginOptionsV1AuthSsoOptionsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Start OIDC SSO login flow by redirecting to the IdP authorize URL.
 * @summary Start Oidc Sso Login
 */
export const startOidcSsoLoginV1AuthSsoOidcStartGet = (
    params: StartOidcSsoLoginV1AuthSsoOidcStartGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/auth/sso/oidc/start`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getStartOidcSsoLoginV1AuthSsoOidcStartGetQueryKey = (params?: StartOidcSsoLoginV1AuthSsoOidcStartGetParams,) => {
    return [
    `/v1/auth/sso/oidc/start`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getStartOidcSsoLoginV1AuthSsoOidcStartGetQueryOptions = <TData = Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>, TError = HTTPValidationError>(params: StartOidcSsoLoginV1AuthSsoOidcStartGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStartOidcSsoLoginV1AuthSsoOidcStartGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>> = ({ signal }) => startOidcSsoLoginV1AuthSsoOidcStartGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type StartOidcSsoLoginV1AuthSsoOidcStartGetQueryResult = NonNullable<Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>>
export type StartOidcSsoLoginV1AuthSsoOidcStartGetQueryError = HTTPValidationError


export function useStartOidcSsoLoginV1AuthSsoOidcStartGet<TData = Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>, TError = HTTPValidationError>(
 params: StartOidcSsoLoginV1AuthSsoOidcStartGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>,
          TError,
          Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStartOidcSsoLoginV1AuthSsoOidcStartGet<TData = Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>, TError = HTTPValidationError>(
 params: StartOidcSsoLoginV1AuthSsoOidcStartGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>,
          TError,
          Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStartOidcSsoLoginV1AuthSsoOidcStartGet<TData = Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>, TError = HTTPValidationError>(
 params: StartOidcSsoLoginV1AuthSsoOidcStartGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Start Oidc Sso Login
 */

export function useStartOidcSsoLoginV1AuthSsoOidcStartGet<TData = Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>, TError = HTTPValidationError>(
 params: StartOidcSsoLoginV1AuthSsoOidcStartGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof startOidcSsoLoginV1AuthSsoOidcStartGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getStartOidcSsoLoginV1AuthSsoOidcStartGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Handle OIDC callback, issue local session tokens, and redirect to frontend.
 * @summary Oidc Sso Callback
 */
export const oidcSsoCallbackV1AuthSsoOidcCallbackGet = (
    params: OidcSsoCallbackV1AuthSsoOidcCallbackGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/auth/sso/oidc/callback`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getOidcSsoCallbackV1AuthSsoOidcCallbackGetQueryKey = (params?: OidcSsoCallbackV1AuthSsoOidcCallbackGetParams,) => {
    return [
    `/v1/auth/sso/oidc/callback`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getOidcSsoCallbackV1AuthSsoOidcCallbackGetQueryOptions = <TData = Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>, TError = HTTPValidationError>(params: OidcSsoCallbackV1AuthSsoOidcCallbackGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOidcSsoCallbackV1AuthSsoOidcCallbackGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>> = ({ signal }) => oidcSsoCallbackV1AuthSsoOidcCallbackGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type OidcSsoCallbackV1AuthSsoOidcCallbackGetQueryResult = NonNullable<Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>>
export type OidcSsoCallbackV1AuthSsoOidcCallbackGetQueryError = HTTPValidationError


export function useOidcSsoCallbackV1AuthSsoOidcCallbackGet<TData = Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>, TError = HTTPValidationError>(
 params: OidcSsoCallbackV1AuthSsoOidcCallbackGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>,
          TError,
          Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOidcSsoCallbackV1AuthSsoOidcCallbackGet<TData = Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>, TError = HTTPValidationError>(
 params: OidcSsoCallbackV1AuthSsoOidcCallbackGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>,
          TError,
          Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useOidcSsoCallbackV1AuthSsoOidcCallbackGet<TData = Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>, TError = HTTPValidationError>(
 params: OidcSsoCallbackV1AuthSsoOidcCallbackGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Oidc Sso Callback
 */

export function useOidcSsoCallbackV1AuthSsoOidcCallbackGet<TData = Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>, TError = HTTPValidationError>(
 params: OidcSsoCallbackV1AuthSsoOidcCallbackGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oidcSsoCallbackV1AuthSsoOidcCallbackGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getOidcSsoCallbackV1AuthSsoOidcCallbackGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Start SAML login flow by redirecting to IdP with AuthnRequest.
 * @summary Start Saml Sso Login
 */
export const startSamlSsoLoginV1AuthSsoSamlStartGet = (
    params: StartSamlSsoLoginV1AuthSsoSamlStartGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/auth/sso/saml/start`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getStartSamlSsoLoginV1AuthSsoSamlStartGetQueryKey = (params?: StartSamlSsoLoginV1AuthSsoSamlStartGetParams,) => {
    return [
    `/v1/auth/sso/saml/start`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getStartSamlSsoLoginV1AuthSsoSamlStartGetQueryOptions = <TData = Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>, TError = HTTPValidationError>(params: StartSamlSsoLoginV1AuthSsoSamlStartGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStartSamlSsoLoginV1AuthSsoSamlStartGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>> = ({ signal }) => startSamlSsoLoginV1AuthSsoSamlStartGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type StartSamlSsoLoginV1AuthSsoSamlStartGetQueryResult = NonNullable<Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>>
export type StartSamlSsoLoginV1AuthSsoSamlStartGetQueryError = HTTPValidationError


export function useStartSamlSsoLoginV1AuthSsoSamlStartGet<TData = Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>, TError = HTTPValidationError>(
 params: StartSamlSsoLoginV1AuthSsoSamlStartGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>,
          TError,
          Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStartSamlSsoLoginV1AuthSsoSamlStartGet<TData = Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>, TError = HTTPValidationError>(
 params: StartSamlSsoLoginV1AuthSsoSamlStartGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>,
          TError,
          Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStartSamlSsoLoginV1AuthSsoSamlStartGet<TData = Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>, TError = HTTPValidationError>(
 params: StartSamlSsoLoginV1AuthSsoSamlStartGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Start Saml Sso Login
 */

export function useStartSamlSsoLoginV1AuthSsoSamlStartGet<TData = Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>, TError = HTTPValidationError>(
 params: StartSamlSsoLoginV1AuthSsoSamlStartGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof startSamlSsoLoginV1AuthSsoSamlStartGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getStartSamlSsoLoginV1AuthSsoSamlStartGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * SAML Assertion Consumer Service endpoint.

Consumes IdP POSTed assertions, resolves user identity, and redirects to frontend.
 * @summary Saml Sso Acs
 */
export const samlSsoAcsV1AuthSsoSamlAcsPost = (
    bodySamlSsoAcsV1AuthSsoSamlAcsPost: BodySamlSsoAcsV1AuthSsoSamlAcsPost,
 signal?: AbortSignal
) => {
      
      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append(`SAMLResponse`, bodySamlSsoAcsV1AuthSsoSamlAcsPost.SAMLResponse)
if(bodySamlSsoAcsV1AuthSsoSamlAcsPost.RelayState !== undefined && bodySamlSsoAcsV1AuthSsoSamlAcsPost.RelayState !== null) {
 formUrlEncoded.append(`RelayState`, bodySamlSsoAcsV1AuthSsoSamlAcsPost.RelayState)
 }

      return customInstance<string>(
      {url: `/v1/auth/sso/saml/acs`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded, signal
    },
      );
    }
  


export const getSamlSsoAcsV1AuthSsoSamlAcsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof samlSsoAcsV1AuthSsoSamlAcsPost>>, TError,{data: BodySamlSsoAcsV1AuthSsoSamlAcsPost}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof samlSsoAcsV1AuthSsoSamlAcsPost>>, TError,{data: BodySamlSsoAcsV1AuthSsoSamlAcsPost}, TContext> => {

const mutationKey = ['samlSsoAcsV1AuthSsoSamlAcsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof samlSsoAcsV1AuthSsoSamlAcsPost>>, {data: BodySamlSsoAcsV1AuthSsoSamlAcsPost}> = (props) => {
          const {data} = props ?? {};

          return  samlSsoAcsV1AuthSsoSamlAcsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SamlSsoAcsV1AuthSsoSamlAcsPostMutationResult = NonNullable<Awaited<ReturnType<typeof samlSsoAcsV1AuthSsoSamlAcsPost>>>
    export type SamlSsoAcsV1AuthSsoSamlAcsPostMutationBody = BodySamlSsoAcsV1AuthSsoSamlAcsPost
    export type SamlSsoAcsV1AuthSsoSamlAcsPostMutationError = HTTPValidationError

    /**
 * @summary Saml Sso Acs
 */
export const useSamlSsoAcsV1AuthSsoSamlAcsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof samlSsoAcsV1AuthSsoSamlAcsPost>>, TError,{data: BodySamlSsoAcsV1AuthSsoSamlAcsPost}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof samlSsoAcsV1AuthSsoSamlAcsPost>>,
        TError,
        {data: BodySamlSsoAcsV1AuthSsoSamlAcsPost},
        TContext
      > => {

      const mutationOptions = getSamlSsoAcsV1AuthSsoSamlAcsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Redeem a browser-bound, single-use SSO code for local session tokens.
 * @summary Exchange Sso Login Code
 */
export const exchangeSsoLoginCodeV1AuthSsoExchangePost = (
    sSOCodeExchangeRequest: SSOCodeExchangeRequest,
 signal?: AbortSignal
) => {


      return customInstance<SSOCodeExchangeResponse>(
      {url: `/v1/auth/sso/exchange`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sSOCodeExchangeRequest, signal
    },
      );
    }



export const getExchangeSsoLoginCodeV1AuthSsoExchangePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeSsoLoginCodeV1AuthSsoExchangePost>>, TError,{data: SSOCodeExchangeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exchangeSsoLoginCodeV1AuthSsoExchangePost>>, TError,{data: SSOCodeExchangeRequest}, TContext> => {

const mutationKey = ['exchangeSsoLoginCodeV1AuthSsoExchangePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exchangeSsoLoginCodeV1AuthSsoExchangePost>>, {data: SSOCodeExchangeRequest}> = (props) => {
          const {data} = props ?? {};

          return  exchangeSsoLoginCodeV1AuthSsoExchangePost(data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type ExchangeSsoLoginCodeV1AuthSsoExchangePostMutationResult = NonNullable<Awaited<ReturnType<typeof exchangeSsoLoginCodeV1AuthSsoExchangePost>>>
    export type ExchangeSsoLoginCodeV1AuthSsoExchangePostMutationBody = SSOCodeExchangeRequest
    export type ExchangeSsoLoginCodeV1AuthSsoExchangePostMutationError = HTTPValidationError

    /**
 * @summary Exchange Sso Login Code
 */
export const useExchangeSsoLoginCodeV1AuthSsoExchangePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeSsoLoginCodeV1AuthSsoExchangePost>>, TError,{data: SSOCodeExchangeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof exchangeSsoLoginCodeV1AuthSsoExchangePost>>,
        TError,
        {data: SSOCodeExchangeRequest},
        TContext
      > => {

      const mutationOptions = getExchangeSsoLoginCodeV1AuthSsoExchangePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Refresh access token using refresh token.

Returns new access token and refresh token.
 * @summary Refresh Token
 */
export const refreshTokenV1AuthRefreshPost = (
    refreshTokenRequest: RefreshTokenRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LoginResponse>(
      {url: `/v1/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshTokenRequest, signal
    },
      );
    }
  


export const getRefreshTokenV1AuthRefreshPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshTokenV1AuthRefreshPost>>, TError,{data: RefreshTokenRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof refreshTokenV1AuthRefreshPost>>, TError,{data: RefreshTokenRequest}, TContext> => {

const mutationKey = ['refreshTokenV1AuthRefreshPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshTokenV1AuthRefreshPost>>, {data: RefreshTokenRequest}> = (props) => {
          const {data} = props ?? {};

          return  refreshTokenV1AuthRefreshPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshTokenV1AuthRefreshPostMutationResult = NonNullable<Awaited<ReturnType<typeof refreshTokenV1AuthRefreshPost>>>
    export type RefreshTokenV1AuthRefreshPostMutationBody = RefreshTokenRequest
    export type RefreshTokenV1AuthRefreshPostMutationError = HTTPValidationError

    /**
 * @summary Refresh Token
 */
export const useRefreshTokenV1AuthRefreshPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshTokenV1AuthRefreshPost>>, TError,{data: RefreshTokenRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshTokenV1AuthRefreshPost>>,
        TError,
        {data: RefreshTokenRequest},
        TContext
      > => {

      const mutationOptions = getRefreshTokenV1AuthRefreshPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Logout user and invalidate session.
 * @summary Logout
 */
export const logoutV1AuthLogoutPost = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/auth/logout`, method: 'POST', signal
    },
      );
    }
  


export const getLogoutV1AuthLogoutPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutV1AuthLogoutPost>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logoutV1AuthLogoutPost>>, TError,void, TContext> => {

const mutationKey = ['logoutV1AuthLogoutPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutV1AuthLogoutPost>>, void> = () => {
          

          return  logoutV1AuthLogoutPost()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutV1AuthLogoutPostMutationResult = NonNullable<Awaited<ReturnType<typeof logoutV1AuthLogoutPost>>>
    
    export type LogoutV1AuthLogoutPostMutationError = unknown

    /**
 * @summary Logout
 */
export const useLogoutV1AuthLogoutPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutV1AuthLogoutPost>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logoutV1AuthLogoutPost>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutV1AuthLogoutPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get current user profile information.
 * @summary Get Current User Profile
 */
export const getCurrentUserProfileV1AuthMeGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserProfile>(
      {url: `/v1/auth/me`, method: 'GET', signal
    },
      );
    }
  



export const getGetCurrentUserProfileV1AuthMeGetQueryKey = () => {
    return [
    `/v1/auth/me`
    ] as const;
    }

    
export const getGetCurrentUserProfileV1AuthMeGetQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserProfileV1AuthMeGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>> = ({ signal }) => getCurrentUserProfileV1AuthMeGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCurrentUserProfileV1AuthMeGetQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>>
export type GetCurrentUserProfileV1AuthMeGetQueryError = unknown


export function useGetCurrentUserProfileV1AuthMeGet<TData = Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCurrentUserProfileV1AuthMeGet<TData = Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCurrentUserProfileV1AuthMeGet<TData = Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Current User Profile
 */

export function useGetCurrentUserProfileV1AuthMeGet<TData = Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserProfileV1AuthMeGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCurrentUserProfileV1AuthMeGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Check if current user has specified permissions.
 * @summary Check Permissions
 */
export const checkPermissionsV1AuthCheckPermissionsPost = (
    permissionCheckRequest: PermissionCheckRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PermissionCheckResponse>(
      {url: `/v1/auth/check-permissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: permissionCheckRequest, signal
    },
      );
    }
  


export const getCheckPermissionsV1AuthCheckPermissionsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkPermissionsV1AuthCheckPermissionsPost>>, TError,{data: PermissionCheckRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkPermissionsV1AuthCheckPermissionsPost>>, TError,{data: PermissionCheckRequest}, TContext> => {

const mutationKey = ['checkPermissionsV1AuthCheckPermissionsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkPermissionsV1AuthCheckPermissionsPost>>, {data: PermissionCheckRequest}> = (props) => {
          const {data} = props ?? {};

          return  checkPermissionsV1AuthCheckPermissionsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CheckPermissionsV1AuthCheckPermissionsPostMutationResult = NonNullable<Awaited<ReturnType<typeof checkPermissionsV1AuthCheckPermissionsPost>>>
    export type CheckPermissionsV1AuthCheckPermissionsPostMutationBody = PermissionCheckRequest
    export type CheckPermissionsV1AuthCheckPermissionsPostMutationError = HTTPValidationError

    /**
 * @summary Check Permissions
 */
export const useCheckPermissionsV1AuthCheckPermissionsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkPermissionsV1AuthCheckPermissionsPost>>, TError,{data: PermissionCheckRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkPermissionsV1AuthCheckPermissionsPost>>,
        TError,
        {data: PermissionCheckRequest},
        TContext
      > => {

      const mutationOptions = getCheckPermissionsV1AuthCheckPermissionsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Create new user account.

Requires 'users:create' permission.
 * @summary Create User
 */
export const createUserV1AuthUsersPost = (
    createUserRequest: CreateUserRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserProfile>(
      {url: `/v1/auth/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRequest, signal
    },
      );
    }
  


export const getCreateUserV1AuthUsersPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserV1AuthUsersPost>>, TError,{data: CreateUserRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createUserV1AuthUsersPost>>, TError,{data: CreateUserRequest}, TContext> => {

const mutationKey = ['createUserV1AuthUsersPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserV1AuthUsersPost>>, {data: CreateUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  createUserV1AuthUsersPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserV1AuthUsersPostMutationResult = NonNullable<Awaited<ReturnType<typeof createUserV1AuthUsersPost>>>
    export type CreateUserV1AuthUsersPostMutationBody = CreateUserRequest
    export type CreateUserV1AuthUsersPostMutationError = HTTPValidationError

    /**
 * @summary Create User
 */
export const useCreateUserV1AuthUsersPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserV1AuthUsersPost>>, TError,{data: CreateUserRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserV1AuthUsersPost>>,
        TError,
        {data: CreateUserRequest},
        TContext
      > => {

      const mutationOptions = getCreateUserV1AuthUsersPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Change current user's password.
 * @summary Change Password
 */
export const changePasswordV1AuthMePasswordPut = (
    changePasswordRequest: ChangePasswordRequest,
 ) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/auth/me/password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changePasswordRequest
    },
      );
    }
  


export const getChangePasswordV1AuthMePasswordPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePasswordV1AuthMePasswordPut>>, TError,{data: ChangePasswordRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof changePasswordV1AuthMePasswordPut>>, TError,{data: ChangePasswordRequest}, TContext> => {

const mutationKey = ['changePasswordV1AuthMePasswordPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePasswordV1AuthMePasswordPut>>, {data: ChangePasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  changePasswordV1AuthMePasswordPut(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordV1AuthMePasswordPutMutationResult = NonNullable<Awaited<ReturnType<typeof changePasswordV1AuthMePasswordPut>>>
    export type ChangePasswordV1AuthMePasswordPutMutationBody = ChangePasswordRequest
    export type ChangePasswordV1AuthMePasswordPutMutationError = HTTPValidationError

    /**
 * @summary Change Password
 */
export const useChangePasswordV1AuthMePasswordPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePasswordV1AuthMePasswordPut>>, TError,{data: ChangePasswordRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePasswordV1AuthMePasswordPut>>,
        TError,
        {data: ChangePasswordRequest},
        TContext
      > => {

      const mutationOptions = getChangePasswordV1AuthMePasswordPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Complete a password reset using an admin-issued reset-link token.
 * @summary Confirm Password Reset
 */
export const confirmPasswordResetV1AuthPasswordResetConfirmPost = (
    passwordResetConfirmRequest: PasswordResetConfirmRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/auth/password-reset/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordResetConfirmRequest, signal
    },
      );
    }
  


export const getConfirmPasswordResetV1AuthPasswordResetConfirmPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPasswordResetV1AuthPasswordResetConfirmPost>>, TError,{data: PasswordResetConfirmRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmPasswordResetV1AuthPasswordResetConfirmPost>>, TError,{data: PasswordResetConfirmRequest}, TContext> => {

const mutationKey = ['confirmPasswordResetV1AuthPasswordResetConfirmPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmPasswordResetV1AuthPasswordResetConfirmPost>>, {data: PasswordResetConfirmRequest}> = (props) => {
          const {data} = props ?? {};

          return  confirmPasswordResetV1AuthPasswordResetConfirmPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmPasswordResetV1AuthPasswordResetConfirmPostMutationResult = NonNullable<Awaited<ReturnType<typeof confirmPasswordResetV1AuthPasswordResetConfirmPost>>>
    export type ConfirmPasswordResetV1AuthPasswordResetConfirmPostMutationBody = PasswordResetConfirmRequest
    export type ConfirmPasswordResetV1AuthPasswordResetConfirmPostMutationError = HTTPValidationError

    /**
 * @summary Confirm Password Reset
 */
export const useConfirmPasswordResetV1AuthPasswordResetConfirmPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPasswordResetV1AuthPasswordResetConfirmPost>>, TError,{data: PasswordResetConfirmRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmPasswordResetV1AuthPasswordResetConfirmPost>>,
        TError,
        {data: PasswordResetConfirmRequest},
        TContext
      > => {

      const mutationOptions = getConfirmPasswordResetV1AuthPasswordResetConfirmPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Self-serve password reset request.

Always returns a generic 200 response to avoid leaking which email addresses
exist in the platform. If a matching active user is found, a signed reset
token is generated and queued for email delivery via the platform email
service. The token uses ``type=self_serve_password_reset`` and expires in
30 minutes.
 * @summary Request Password Reset
 */
export const requestPasswordResetV1AuthPasswordResetRequestPost = (
    forgotPasswordRequest: ForgotPasswordRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ForgotPasswordResponse>(
      {url: `/v1/auth/password-reset/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forgotPasswordRequest, signal
    },
      );
    }
  


export const getRequestPasswordResetV1AuthPasswordResetRequestPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPasswordResetV1AuthPasswordResetRequestPost>>, TError,{data: ForgotPasswordRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof requestPasswordResetV1AuthPasswordResetRequestPost>>, TError,{data: ForgotPasswordRequest}, TContext> => {

const mutationKey = ['requestPasswordResetV1AuthPasswordResetRequestPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPasswordResetV1AuthPasswordResetRequestPost>>, {data: ForgotPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  requestPasswordResetV1AuthPasswordResetRequestPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestPasswordResetV1AuthPasswordResetRequestPostMutationResult = NonNullable<Awaited<ReturnType<typeof requestPasswordResetV1AuthPasswordResetRequestPost>>>
    export type RequestPasswordResetV1AuthPasswordResetRequestPostMutationBody = ForgotPasswordRequest
    export type RequestPasswordResetV1AuthPasswordResetRequestPostMutationError = HTTPValidationError

    /**
 * @summary Request Password Reset
 */
export const useRequestPasswordResetV1AuthPasswordResetRequestPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPasswordResetV1AuthPasswordResetRequestPost>>, TError,{data: ForgotPasswordRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestPasswordResetV1AuthPasswordResetRequestPost>>,
        TError,
        {data: ForgotPasswordRequest},
        TContext
      > => {

      const mutationOptions = getRequestPasswordResetV1AuthPasswordResetRequestPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Complete a self-serve password reset using a signed reset-link token.
 * @summary Confirm Self Serve Password Reset
 */
export const confirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPost = (
    passwordResetConfirmRequest: PasswordResetConfirmRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/auth/password-reset/self-serve/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordResetConfirmRequest, signal
    },
      );
    }
  


export const getConfirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPost>>, TError,{data: PasswordResetConfirmRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPost>>, TError,{data: PasswordResetConfirmRequest}, TContext> => {

const mutationKey = ['confirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPost>>, {data: PasswordResetConfirmRequest}> = (props) => {
          const {data} = props ?? {};

          return  confirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPostMutationResult = NonNullable<Awaited<ReturnType<typeof confirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPost>>>
    export type ConfirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPostMutationBody = PasswordResetConfirmRequest
    export type ConfirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPostMutationError = HTTPValidationError

    /**
 * @summary Confirm Self Serve Password Reset
 */
export const useConfirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPost>>, TError,{data: PasswordResetConfirmRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPost>>,
        TError,
        {data: PasswordResetConfirmRequest},
        TContext
      > => {

      const mutationOptions = getConfirmSelfServePasswordResetV1AuthPasswordResetSelfServeConfirmPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Health check for authentication service.
 * @summary Auth Health Check
 */
export const authHealthCheckV1AuthHealthGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/auth/health`, method: 'GET', signal
    },
      );
    }
  



export const getAuthHealthCheckV1AuthHealthGetQueryKey = () => {
    return [
    `/v1/auth/health`
    ] as const;
    }

    
export const getAuthHealthCheckV1AuthHealthGetQueryOptions = <TData = Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthHealthCheckV1AuthHealthGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>> = ({ signal }) => authHealthCheckV1AuthHealthGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AuthHealthCheckV1AuthHealthGetQueryResult = NonNullable<Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>>
export type AuthHealthCheckV1AuthHealthGetQueryError = unknown


export function useAuthHealthCheckV1AuthHealthGet<TData = Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>,
          TError,
          Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAuthHealthCheckV1AuthHealthGet<TData = Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>,
          TError,
          Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAuthHealthCheckV1AuthHealthGet<TData = Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Auth Health Check
 */

export function useAuthHealthCheckV1AuthHealthGet<TData = Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authHealthCheckV1AuthHealthGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAuthHealthCheckV1AuthHealthGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get all active sessions for the current user.
 * @summary Get User Sessions
 */
export const getUserSessionsV1AuthSessionsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserSessionsResponse>(
      {url: `/v1/auth/sessions`, method: 'GET', signal
    },
      );
    }
  



export const getGetUserSessionsV1AuthSessionsGetQueryKey = () => {
    return [
    `/v1/auth/sessions`
    ] as const;
    }

    
export const getGetUserSessionsV1AuthSessionsGetQueryOptions = <TData = Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSessionsV1AuthSessionsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>> = ({ signal }) => getUserSessionsV1AuthSessionsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserSessionsV1AuthSessionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>>
export type GetUserSessionsV1AuthSessionsGetQueryError = unknown


export function useGetUserSessionsV1AuthSessionsGet<TData = Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>,
          TError,
          Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserSessionsV1AuthSessionsGet<TData = Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>,
          TError,
          Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserSessionsV1AuthSessionsGet<TData = Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get User Sessions
 */

export function useGetUserSessionsV1AuthSessionsGet<TData = Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserSessionsV1AuthSessionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserSessionsV1AuthSessionsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Terminate all sessions for the current user.
 * @summary Terminate All Sessions
 */
export const terminateAllSessionsV1AuthSessionsDelete = (
    params?: TerminateAllSessionsV1AuthSessionsDeleteParams,
 ) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/auth/sessions`, method: 'DELETE',
        params
    },
      );
    }
  


export const getTerminateAllSessionsV1AuthSessionsDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof terminateAllSessionsV1AuthSessionsDelete>>, TError,{params?: TerminateAllSessionsV1AuthSessionsDeleteParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof terminateAllSessionsV1AuthSessionsDelete>>, TError,{params?: TerminateAllSessionsV1AuthSessionsDeleteParams}, TContext> => {

const mutationKey = ['terminateAllSessionsV1AuthSessionsDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof terminateAllSessionsV1AuthSessionsDelete>>, {params?: TerminateAllSessionsV1AuthSessionsDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  terminateAllSessionsV1AuthSessionsDelete(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TerminateAllSessionsV1AuthSessionsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof terminateAllSessionsV1AuthSessionsDelete>>>
    
    export type TerminateAllSessionsV1AuthSessionsDeleteMutationError = HTTPValidationError

    /**
 * @summary Terminate All Sessions
 */
export const useTerminateAllSessionsV1AuthSessionsDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof terminateAllSessionsV1AuthSessionsDelete>>, TError,{params?: TerminateAllSessionsV1AuthSessionsDeleteParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof terminateAllSessionsV1AuthSessionsDelete>>,
        TError,
        {params?: TerminateAllSessionsV1AuthSessionsDeleteParams},
        TContext
      > => {

      const mutationOptions = getTerminateAllSessionsV1AuthSessionsDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Terminate a specific session.
 * @summary Terminate Session
 */
export const terminateSessionV1AuthSessionsSessionTokenDelete = (
    sessionToken: string,
 ) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/auth/sessions/${sessionToken}`, method: 'DELETE'
    },
      );
    }
  


export const getTerminateSessionV1AuthSessionsSessionTokenDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof terminateSessionV1AuthSessionsSessionTokenDelete>>, TError,{sessionToken: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof terminateSessionV1AuthSessionsSessionTokenDelete>>, TError,{sessionToken: string}, TContext> => {

const mutationKey = ['terminateSessionV1AuthSessionsSessionTokenDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof terminateSessionV1AuthSessionsSessionTokenDelete>>, {sessionToken: string}> = (props) => {
          const {sessionToken} = props ?? {};

          return  terminateSessionV1AuthSessionsSessionTokenDelete(sessionToken,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TerminateSessionV1AuthSessionsSessionTokenDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof terminateSessionV1AuthSessionsSessionTokenDelete>>>
    
    export type TerminateSessionV1AuthSessionsSessionTokenDeleteMutationError = HTTPValidationError

    /**
 * @summary Terminate Session
 */
export const useTerminateSessionV1AuthSessionsSessionTokenDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof terminateSessionV1AuthSessionsSessionTokenDelete>>, TError,{sessionToken: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof terminateSessionV1AuthSessionsSessionTokenDelete>>,
        TError,
        {sessionToken: string},
        TContext
      > => {

      const mutationOptions = getTerminateSessionV1AuthSessionsSessionTokenDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get invite information by token (public endpoint).

Used to validate invite and show user info before they set their password.
 * @summary Get Invite Info
 */
export const getInviteInfoV1AuthInviteTokenGet = (
    token: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<InviteInfoResponse>(
      {url: `/v1/auth/invite/${token}`, method: 'GET', signal
    },
      );
    }
  



export const getGetInviteInfoV1AuthInviteTokenGetQueryKey = (token?: string,) => {
    return [
    `/v1/auth/invite/${token}`
    ] as const;
    }

    
export const getGetInviteInfoV1AuthInviteTokenGetQueryOptions = <TData = Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>, TError = HTTPValidationError>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInviteInfoV1AuthInviteTokenGetQueryKey(token);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>> = ({ signal }) => getInviteInfoV1AuthInviteTokenGet(token, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetInviteInfoV1AuthInviteTokenGetQueryResult = NonNullable<Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>>
export type GetInviteInfoV1AuthInviteTokenGetQueryError = HTTPValidationError


export function useGetInviteInfoV1AuthInviteTokenGet<TData = Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>, TError = HTTPValidationError>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>,
          TError,
          Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetInviteInfoV1AuthInviteTokenGet<TData = Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>,
          TError,
          Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetInviteInfoV1AuthInviteTokenGet<TData = Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Invite Info
 */

export function useGetInviteInfoV1AuthInviteTokenGet<TData = Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>, TError = HTTPValidationError>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInviteInfoV1AuthInviteTokenGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetInviteInfoV1AuthInviteTokenGetQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Accept an invite and create user account (public endpoint).

Creates the user, assigns pre-configured roles, and marks invite as accepted.
 * @summary Accept Invite
 */
export const acceptInviteV1AuthInviteAcceptPost = (
    acceptInviteRequest: AcceptInviteRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AcceptInviteResponse>(
      {url: `/v1/auth/invite/accept`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acceptInviteRequest, signal
    },
      );
    }
  


export const getAcceptInviteV1AuthInviteAcceptPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInviteV1AuthInviteAcceptPost>>, TError,{data: AcceptInviteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptInviteV1AuthInviteAcceptPost>>, TError,{data: AcceptInviteRequest}, TContext> => {

const mutationKey = ['acceptInviteV1AuthInviteAcceptPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInviteV1AuthInviteAcceptPost>>, {data: AcceptInviteRequest}> = (props) => {
          const {data} = props ?? {};

          return  acceptInviteV1AuthInviteAcceptPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptInviteV1AuthInviteAcceptPostMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInviteV1AuthInviteAcceptPost>>>
    export type AcceptInviteV1AuthInviteAcceptPostMutationBody = AcceptInviteRequest
    export type AcceptInviteV1AuthInviteAcceptPostMutationError = HTTPValidationError

    /**
 * @summary Accept Invite
 */
export const useAcceptInviteV1AuthInviteAcceptPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInviteV1AuthInviteAcceptPost>>, TError,{data: AcceptInviteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInviteV1AuthInviteAcceptPost>>,
        TError,
        {data: AcceptInviteRequest},
        TContext
      > => {

      const mutationOptions = getAcceptInviteV1AuthInviteAcceptPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Accept an invite for an existing user (public endpoint).

This endpoint is for users who already have an account and are being
invited to a new tenant. No password required - they just need to
click accept and then log in.
 * @summary Accept Invite Existing User
 */
export const acceptInviteExistingUserV1AuthInviteAcceptExistingPost = (
    acceptInviteExistingUserRequest: AcceptInviteExistingUserRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AcceptInviteResponse>(
      {url: `/v1/auth/invite/accept-existing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acceptInviteExistingUserRequest, signal
    },
      );
    }
  


export const getAcceptInviteExistingUserV1AuthInviteAcceptExistingPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInviteExistingUserV1AuthInviteAcceptExistingPost>>, TError,{data: AcceptInviteExistingUserRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptInviteExistingUserV1AuthInviteAcceptExistingPost>>, TError,{data: AcceptInviteExistingUserRequest}, TContext> => {

const mutationKey = ['acceptInviteExistingUserV1AuthInviteAcceptExistingPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInviteExistingUserV1AuthInviteAcceptExistingPost>>, {data: AcceptInviteExistingUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  acceptInviteExistingUserV1AuthInviteAcceptExistingPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptInviteExistingUserV1AuthInviteAcceptExistingPostMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInviteExistingUserV1AuthInviteAcceptExistingPost>>>
    export type AcceptInviteExistingUserV1AuthInviteAcceptExistingPostMutationBody = AcceptInviteExistingUserRequest
    export type AcceptInviteExistingUserV1AuthInviteAcceptExistingPostMutationError = HTTPValidationError

    /**
 * @summary Accept Invite Existing User
 */
export const useAcceptInviteExistingUserV1AuthInviteAcceptExistingPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInviteExistingUserV1AuthInviteAcceptExistingPost>>, TError,{data: AcceptInviteExistingUserRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInviteExistingUserV1AuthInviteAcceptExistingPost>>,
        TError,
        {data: AcceptInviteExistingUserRequest},
        TContext
      > => {

      const mutationOptions = getAcceptInviteExistingUserV1AuthInviteAcceptExistingPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get all tenants the current user belongs to.

Returns list of tenant memberships with current active tenant.
 * @summary Get My Tenants
 */
export const getMyTenantsV1AuthTenantsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<TenantMembershipsResponse>(
      {url: `/v1/auth/tenants`, method: 'GET', signal
    },
      );
    }
  



export const getGetMyTenantsV1AuthTenantsGetQueryKey = () => {
    return [
    `/v1/auth/tenants`
    ] as const;
    }

    
export const getGetMyTenantsV1AuthTenantsGetQueryOptions = <TData = Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyTenantsV1AuthTenantsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>> = ({ signal }) => getMyTenantsV1AuthTenantsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyTenantsV1AuthTenantsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>>
export type GetMyTenantsV1AuthTenantsGetQueryError = unknown


export function useGetMyTenantsV1AuthTenantsGet<TData = Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>,
          TError,
          Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyTenantsV1AuthTenantsGet<TData = Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>,
          TError,
          Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyTenantsV1AuthTenantsGet<TData = Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get My Tenants
 */

export function useGetMyTenantsV1AuthTenantsGet<TData = Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTenantsV1AuthTenantsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyTenantsV1AuthTenantsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Switch to a different tenant.

Issues new tokens with the target tenant as the active tenant.
User must be a member of the target tenant.
 * @summary Switch Tenant
 */
export const switchTenantV1AuthSwitchTenantPost = (
    switchTenantRequest: SwitchTenantRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SwitchTenantResponse>(
      {url: `/v1/auth/switch-tenant`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: switchTenantRequest, signal
    },
      );
    }
  


export const getSwitchTenantV1AuthSwitchTenantPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchTenantV1AuthSwitchTenantPost>>, TError,{data: SwitchTenantRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof switchTenantV1AuthSwitchTenantPost>>, TError,{data: SwitchTenantRequest}, TContext> => {

const mutationKey = ['switchTenantV1AuthSwitchTenantPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof switchTenantV1AuthSwitchTenantPost>>, {data: SwitchTenantRequest}> = (props) => {
          const {data} = props ?? {};

          return  switchTenantV1AuthSwitchTenantPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SwitchTenantV1AuthSwitchTenantPostMutationResult = NonNullable<Awaited<ReturnType<typeof switchTenantV1AuthSwitchTenantPost>>>
    export type SwitchTenantV1AuthSwitchTenantPostMutationBody = SwitchTenantRequest
    export type SwitchTenantV1AuthSwitchTenantPostMutationError = HTTPValidationError

    /**
 * @summary Switch Tenant
 */
export const useSwitchTenantV1AuthSwitchTenantPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchTenantV1AuthSwitchTenantPost>>, TError,{data: SwitchTenantRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof switchTenantV1AuthSwitchTenantPost>>,
        TError,
        {data: SwitchTenantRequest},
        TContext
      > => {

      const mutationOptions = getSwitchTenantV1AuthSwitchTenantPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Set the default tenant for the current user.

The default tenant is used when logging in.
 * @summary Set Default Tenant
 */
export const setDefaultTenantV1AuthDefaultTenantPut = (
    setDefaultTenantRequest: SetDefaultTenantRequest,
 ) => {
      
      
      return customInstance<SetDefaultTenantResponse>(
      {url: `/v1/auth/default-tenant`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setDefaultTenantRequest
    },
      );
    }
  


export const getSetDefaultTenantV1AuthDefaultTenantPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultTenantV1AuthDefaultTenantPut>>, TError,{data: SetDefaultTenantRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setDefaultTenantV1AuthDefaultTenantPut>>, TError,{data: SetDefaultTenantRequest}, TContext> => {

const mutationKey = ['setDefaultTenantV1AuthDefaultTenantPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDefaultTenantV1AuthDefaultTenantPut>>, {data: SetDefaultTenantRequest}> = (props) => {
          const {data} = props ?? {};

          return  setDefaultTenantV1AuthDefaultTenantPut(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetDefaultTenantV1AuthDefaultTenantPutMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultTenantV1AuthDefaultTenantPut>>>
    export type SetDefaultTenantV1AuthDefaultTenantPutMutationBody = SetDefaultTenantRequest
    export type SetDefaultTenantV1AuthDefaultTenantPutMutationError = HTTPValidationError

    /**
 * @summary Set Default Tenant
 */
export const useSetDefaultTenantV1AuthDefaultTenantPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultTenantV1AuthDefaultTenantPut>>, TError,{data: SetDefaultTenantRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDefaultTenantV1AuthDefaultTenantPut>>,
        TError,
        {data: SetDefaultTenantRequest},
        TContext
      > => {

      const mutationOptions = getSetDefaultTenantV1AuthDefaultTenantPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }

